import React from "react";

interface Customer {
  id: number;
  name: string;
  phone: string;
  email: string;
  address: string;
  orgNumber: string;
}

interface Props {
  customers: Customer[];
}

const Customers = ({ customers }: Props) => {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold">Kunder</h2>
      {customers.length === 0 && (
        <p className="text-gray-500">Ingen kunder registrert enda.</p>
      )}
      <ul className="divide-y divide-gray-200">
        {customers.map((c) => (
          <li key={c.id} className="py-3">
            <div className="font-semibold">{c.name}</div>
            <div className="text-sm text-gray-600">
              Tlf: {c.phone} | E-post: {c.email} | Org.nr: {c.orgNumber}
            </div>
            <div className="text-sm text-gray-600">{c.address}</div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Customers;
